import "../App.css";

import phase1 from "../assets/images/phase-1.png";
import phase2 from "../assets/images/phase-2.png";
import phase3 from "../assets/images/phase-3.png";
import phase4 from "../assets/images/phase-4.png";

const roadmap = [

    {
        phase: "PHASE 1",
        title: "Launch the Flock",
        text: "Build the foundation and grow the community.",
        image: phase1,
        color: "#F5B800",
        bg: "#FFF8E8"
    },

    {
        phase: "PHASE 2",
        title: "Expand Routes",
        text: "Add more features and travel partnerships.",
        image: phase2,
        color: "#2C7BE5",
        bg: "#EFF7FF"
    },

    {
        phase: "PHASE 3",
        title: "Booking Engine",
        text: "Launch the flight booking platform and utilities.",
        image: phase3,
        color: "#FF5A1F",
        bg: "#FFF5EC"
    },

    {
        phase: "PHASE 4",
        title: "Revenue Sharing",
        text: "Buybacks and holder rewards from real revenue.",
        image: phase4,
        color: "#8E5CF6",
        bg: "#F8F2FF"
    }

];

function Roadmap(){

    return(

        <section className="roadmap-section" id="roadmap">

            <div className="container">

                <h2>ROADMAP</h2>
                <span class="title-line"></span>

                <div className="roadmap-wrapper">

                    {

                        roadmap.map((item,index)=>(

                            <>

                            <div
                                className="roadmap-card"
                                key={index}
                                style={{
                                    background:item.bg,
                                    borderColor:item.color
                                }}
                            >

                                <img
                                    src={item.image}
                                    alt=""
                                />

                                <div className="roadmap-content">

                                    <span
                                        style={{
                                            color:item.color
                                        }}
                                    >
                                        {item.phase}
                                    </span>

                                    <h4>{item.title}</h4>

                                    <p>{item.text}</p>

                                </div>

                            </div>

                            {

                                index!==roadmap.length-1 &&

                                <div
                                    className="roadmap-line"
                                    style={{
                                        "--dot":item.color
                                    }}
                                ></div>

                            }

                            </>

                        ))

                    }

                </div>

            </div>

        </section>

    )

}

export default Roadmap;